import React from 'react'
import PublicFooter from '../ui/PublicFooter'
import MarketingSiteHeader from './MarketingSiteHeader'

export default function MarketingSiteLayout({ children }) {
  return (
    <div className="flex min-h-screen flex-col bg-slate-50 text-slate-900">
      <MarketingSiteHeader />
      <main className="flex-1">{children}</main>
      <PublicFooter />
    </div>
  )
}
